// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { dataSlice, toNumber, toUtf8String } from 'ethers';

export const getSubHex = (hexString: string, offset: number, numBytes: number, includePrefix: boolean = false): string => {
  const slice = dataSlice(hexString, offset, offset + numBytes);
  return includePrefix ? slice : slice.slice(2);
};

export const hexToInt = (hexString: string, offset: number, numBytes: number): number => {
  const slice = dataSlice(hexString, offset, offset + numBytes);
  return toNumber(slice);
};

export const hexToText = (hexString: string, offset: number, numBytes: number): string => {
  const slice = dataSlice(hexString, offset, offset + numBytes);
  return toUtf8String(slice).replace(/\0+$/, ''); // Remove trailing null characters
};

const HOOK_DATA_LENGTH_OFFSET = 236;
const HOOK_DATA_LENGTH_NUM_BYTES = 4;
const HOOK_DATA_OFFSET = 240;
const NONCE_OFFSET = 204;
const NONCE_NUM_BYTES = 32;

/**
 * Extracts recipient party from deposit message hook data
 */
export const getRecipientPartyFromHookData = (depositMessage: string): string => {
  if (!depositMessage || depositMessage.trim() === '') {
    return '';
  }

  try {
    const hookDataNumBytes = hexToInt(depositMessage, HOOK_DATA_LENGTH_OFFSET, HOOK_DATA_LENGTH_NUM_BYTES);
    return hexToText(depositMessage, HOOK_DATA_OFFSET, hookDataNumBytes);
  } catch (error) {
    return '';
  }
};

/**
 * Extracts nonce from deposit message
 */
export const getNonceFromDepositMessage = (depositMessage: string): string => {
  if (!depositMessage || depositMessage.trim() === '') {
    return '';
  }

  try {
    return getSubHex(depositMessage, NONCE_OFFSET, NONCE_NUM_BYTES);
  } catch (error) {
    return '';
  }
};
